import {
  GET_REPORTER,
  GET_REPORTER_LANG,
  GET_MEDICAL_HEALTH,
  GET_OUTCOME_REC,
  GET_SEVERITY,
  GET_DONE,
} from '../../types'

const INITIAL_STATE = {
  allReport: [],
  allReporterLang: [],
  allMedicalHealth: [],
  allOutCome: [],
  allSeverity: [],
  allDone:[]
}

const eventCaseReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_REPORTER:
      return {
        ...state,
        allReport: payload,
      }
    case GET_REPORTER_LANG:
      return {
        ...state,
        allReporterLang: payload,
      }
    case GET_MEDICAL_HEALTH:
      return {
        ...state,
        allMedicalHealth: payload,
      }
    case GET_OUTCOME_REC:
      return {
        ...state,
        allOutCome: payload,
      }
    case GET_SEVERITY:
      return {
        ...state,
        allSeverity: payload,
      }
      case GET_DONE:
      return {
        ...state,
        allDone: payload,
      }
    default:
      return state
  }
}

export default eventCaseReducer
